import styled from '@emotion/styled'

import { mq } from '../constants/breakpoints'

const PageContent = styled.div<{ expanded?: boolean }>`
  max-width: ${({ expanded }) => (expanded ? '100%' : '1000px')};
  margin: auto;
  margin-top: 30px;
  padding: 0 20px 100px 20px;

  ${mq.mobile} {
    margin-top: 40px;
  }
`

export default PageContent
